import request from "@/lib/request/request";
import Model from "../../model";

export type RuleType = "" | "enum" | "enums" | "number" | "string" | "strings";

export class RelationShipList {
  relKey = "";
  relName = "";
  valueNeed: RuleType = "";
}

export class RuleGroupItem {
  attrKey = "";
  attrName = "";
  configNeedList: string[] = [];
  relationshipList = [];
  enumList = [];
}

export interface CascadeOption {
  value: string;
  label: string;
  params?: any;
  list?: any;
  children: CascadeOption[] | null;
}

export class Rule extends Model {
  subList: Rule[] = [];
  groupName = "";
  attrDetail: RuleGroupItem = new RuleGroupItem();

  static get(): Promise<Rule[]> {
    return request.postInterviewApi("/hr/company/matchRuleAttr").then(res => {
      return res.data.data.attrGroupList;
    });
  }

  // static regenerateRes(groupList: Rule[], deepth = 0): CascadeOption[] {
  //   const result: CascadeOption[] = [];
  //   groupList.forEach((item, i) => {
  //     const resultItem: CascadeOption = {
  //       key: item?.attrDetail?.attrKey ?? `${deepth}-${i}`,
  //       label: item.groupName,
  //       children: this.regenerateRes(item.subList, deepth + 1)
  //     };
  //     result.push(resultItem);
  //   });
  //   return result;
  // }
}
